module.exports = __webpack_public_path__ + "img/1.65a6d260.png";